import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	repositoryListShowingRepositoryCount: {
		id: 'software-code-code-page.pages.main-page.repositories.repository-list.repository-list-showing-repository-count',
		defaultMessage: 'Showing {visible} of {total}. ',
		description:
			'The label describing how many repository cards are shown out of a total available number of cards.',
	},
	repositoryListShowAllLink: {
		id: 'software-code-code-page.pages.main-page.repositories.repository-list.repository-list-show-all-link',
		defaultMessage: 'Show all',
		description: 'Label for link to reveal all repository cards in the repository list.',
	},
	repositoryListShowFewerLink: {
		id: 'software-code-code-page.pages.main-page.repositories.repository-list.repository-list-show-fewer-link',
		defaultMessage: 'Show fewer',
		description:
			'Label for link to hide all but the first line of repository cards in the repository list.',
	},
});
